// the footer page
import React from 'react'
import "./footer.css"
function Footer() {
    return (
        <div className="footer">
            <p>©2021 No rights reserved ~ It's just a Portfolio Project</p>
            <p>Privacy • Terms  • Sitemap • SourceCode</p>
        </div>
    )
}

export default Footer
